import i18n from "config/i18next";

i18n.addResources("es", "footer", {
  follow: "¡Seguinos!",
  download: "Descargá la app en Play Store",
  downloadMobile: "Descargá la app en",
  needHelp: "¿Necesitás ayuda?",
  contactUs: "Escribinos a ",
});
